export const Monogram = ({ size = 44, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <circle cx="50" cy="50" r="46" stroke="url(#mono_gold)" strokeWidth="3" />
    <path
      d="M30 68V32L45 52L60 32V68"
      stroke="url(#mono_gold)"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70 32C75 32 78 35 78 40V60C78 65 75 68 70 68"
      stroke="url(#mono_gold)"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="mono_gold" x1="0" y1="0" x2="100" y2="100">
        <stop offset="0%" stopColor="#D4AF37" />
        <stop offset="50%" stopColor="#F3E5AB" />
        <stop offset="100%" stopColor="#AA7C11" />
      </linearGradient>
    </defs>
  </svg>
);
